require('../../modules/es6.object.seal');
module.exports = require('../../modules/_core').Object.seal;



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/object/seal.js
// module id = 1470
// module chunks = 0